function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { vsKebabVertical } from '@deephaven/icons';
import { Button, DropdownMenu, Tooltip } from '@deephaven/components';
import "./ConsoleStatusBar.css";
import { EMPTY_FUNCTION } from '@deephaven/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var POPPER_OPTIONS = {
  placement: 'bottom-end'
};
function ConsoleStatusBar(_ref) {
  var children = _ref.children,
    dh = _ref.dh,
    session = _ref.session,
    overflowActions = _ref.overflowActions;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    pendingCommandCount = _useState2[0],
    setPendingCommandCount = _useState2[1];
  var handleCommandStarted = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (event) {
      setPendingCommandCount(count => count + 1);
      try {
        var result = event.detail.result;
        yield result;
      } catch (error) {
        // No-op, fall through
      }
      setPendingCommandCount(count => count - 1);
    });
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  useEffect(function startListening() {
    return session.addEventListener(dh.IdeSession.EVENT_COMMANDSTARTED, handleCommandStarted);
  }, [dh, handleCommandStarted, session]);
  var statusIconClass = null;
  var tooltipText = null;
  if (pendingCommandCount > 0) {
    // Connected, Pending
    statusIconClass = 'console-status-icon-pending';
    tooltipText = 'Worker is busy';
  } else {
    // Connected, Idle
    statusIconClass = 'console-status-icon-idle';
    tooltipText = 'Worker is idle';
  }
  var hasActions = overflowActions != null && (!Array.isArray(overflowActions) || overflowActions.length > 0);
  return /*#__PURE__*/_jsxs("div", {
    className: "console-pane-status-bar",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: classNames('console-status-icon', statusIconClass)
      }), /*#__PURE__*/_jsx(Tooltip, {
        children: tooltipText
      })]
    }), children, hasActions && /*#__PURE__*/_jsx(Button, {
      kind: "ghost",
      icon: vsKebabVertical,
      tooltip: "More Actions...",
      "aria-label": "More Actions..."
      // no-op: click is handled in `DropdownMenu`
      ,
      onClick: EMPTY_FUNCTION,
      children: /*#__PURE__*/_jsx(DropdownMenu, {
        actions: overflowActions,
        popperOptions: POPPER_OPTIONS
      })
    })]
  });
}
export default ConsoleStatusBar;
//# sourceMappingURL=ConsoleStatusBar.js.map